export default {"src":"/_next/static/media/mail-yellow.9ea32cf0.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};